import React from "react";

const HeaderSkeleton = () => {
  return (
    <div className="bg-yellow-500 p-10 md:p-20 animate-pulse">
      <div className="text-center text-white">
        <div className="h-8 md:h-10 bg-white/40 rounded w-1/3 mx-auto"></div>
        <div className="h-4 md:h-5 bg-white/30 rounded w-2/4 mx-auto mt-4"></div>
      </div>
    </div>
  );
};

export default HeaderSkeleton;
